import React, { FC } from 'react';
import { IconProps } from './index';

/**
 * @deprecated use zzm-base
 * @param color
 * @param size
 * @constructor
 */
export const Drag: FC<IconProps> = ({ color = '#FFFFFF', size = 20 }) => {
  return <svg width={size} height={size} viewBox="0 0 20 20" fill={color} xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M5 5.5C5 5.08579 5.33579 4.75 5.75 4.75H14.25C14.6642 4.75 15 5.08579 15 5.5C15 5.91421 14.6642 6.25 14.25 6.25H5.75C5.33579 6.25 5 5.91421 5 5.5ZM5 10C5 9.58579 5.33579 9.25 5.75 9.25H14.25C14.6642 9.25 15 9.58579 15 10C15 10.4142 14.6642 10.75 14.25 10.75H5.75C5.33579 10.75 5 10.4142 5 10ZM5.75 13.75C5.33579 13.75 5 14.0858 5 14.5C5 14.9142 5.33579 15.25 5.75 15.25H14.25C14.6642 15.25 15 14.9142 15 14.5C15 14.0858 14.6642 13.75 14.25 13.75H5.75Z"/>
  </svg>;
};
